import { render, staticRenderFns } from "./TaskCommentTreeView.vue?vue&type=template&id=2513dcfc&"
import script from "./TaskCommentTreeView.vue?vue&type=script&lang=js&"
export * from "./TaskCommentTreeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports